import { useQuery } from "react-query"
import PortfolioService from "~services/PortfolioService"

const usePortfolio = (
  userId: string,
  onSuccessCallback: (data: any[]) => void
) => {
  return useQuery<any[], Error>(
    ["user-portfolio", userId],
    () => {
      return PortfolioService.getUserPortfolio(userId)
    },
    {
      enabled: !!userId, // Enable automatic fetching when userId is provided
      onSuccess: onSuccessCallback,
      refetchOnWindowFocus: false,
    }
  )
}

export default usePortfolio
